import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RememberButtonsComp from 'components/SourceDisplay/RememberButtons';
import AudioSourceDropdownComp from 'components/SourceDisplay/AudioSourceDropdown';
import MicrophoneMuteComp from 'components/SourceDisplay/MicrophoneMute/MicrophoneMute';
import classes from 'components/SourceDisplay/SourceDisplay.module.scss';
import MicrophoneLevel from './MicrophoneLevel';

function MicrophoneDropdown(props) {
  const titleText = () => {
    if (props.title) return props.title;

    if (props.titleClass) {
      return (
        <span className={props.titleClass}>
          <FormattedMessage
            id="components.avSettingsModal.microphone"
            defaultMessage="Microphone"
          />
        </span>
      );
    }

    if (props.isJoinFlowCall) {
      return (
        <FormattedMessage
          id="components.avSettingsModal.selectMic"
          defaultMessage="Select your microphone"
        />
      );
    }

    return (
      <FormattedMessage
        id="components.avSettingsModal.micSettings"
        defaultMessage="Microphone Settings"
      />
    );
  };

  return (
    <div>
      <div className={classes.subHeading}>
        {titleText()}
      </div>
      <div className={classes.dropdownContainer} >
        {props.audioDevices.length ?
          <AudioSourceDropdownComp
            audioDevices={props.audioDevices}
            selectAudioSource={props.selectAudioSource}
            defaultAudioSetting={props.defaultAudioSetting}
            defaultVideoSetting={props.defaultVideoSetting}
            selectedAudioLabel={props.selectedAudioLabel}
          />
          :
          <div className={classes.emptyDropdown}>
            <FormattedMessage
              id="components.avSettingsModal.noMicrophone"
              defaultMessage="No microphone detected"
            />
          </div>
        }
      </div>
      {!props.isInCall &&
        <MicrophoneMuteComp
          toggleAudioMuteSetting={props.toggleAudioMuteSetting}
          defaultAudioSetting={props.defaultAudioSetting}
          isStartingCall={props.isStartingCall}
        />
      }
      {
        !props.isPSTNVisible &&
        <MicrophoneLevel
          microphoneEnabled={props.defaultAudioSetting}
          microphoneDeviceId={props.microphoneDeviceId}
        />
      }
      {
        !props.isPSTNVisible &&
        <div className={classes.dropdownDivider} />
      }
      {props.showRememberButtons &&
        !props.isPSTNVisible &&
        props.audioDevices.length &&
        <RememberButtonsComp
          acquireLocalPrimaryStream={props.acquireLocalPrimaryStream}
          setVideoEnabledDefault={props.setVideoEnabledDefault}
          setAudioEnabledDefault={props.setAudioEnabledDefault}
          defaultVideoSetting={props.defaultVideoSetting}
          defaultAudioSetting={props.defaultAudioSetting}
          selectedSources={props.selectedSources}
          isPSTNVisible={props.isPSTNVisible}
          toggleAudio={props.toggleAudio}
          sections={props.sections}
          type="audio"
        />
      }
    </div>
  );
}

MicrophoneDropdown.propTypes = {
  audioDevices: PT.array.isRequired,
  isPSTNVisible: PT.bool,
  isJoinFlowCall: PT.bool,
  defaultAudioSetting: PT.bool,
  defaultVideoSetting: PT.bool,
  showRememberButtons: PT.bool,
  isStartingCall: PT.bool,
  isInCall: PT.bool,
  selectedAudioLabel: PT.string,
  selectAudioSource: PT.func,
  acquireLocalPrimaryStream: PT.func,
  setVideoEnabledDefault: PT.func,
  setAudioEnabledDefault: PT.func,
  toggleAudioMuteSetting: PT.func,
  selectedSources: PT.object,
  sections: PT.object,
  microphoneDeviceId: PT.string,
  titleClass: PT.string,
  title: PT.string,
  toggleAudio: PT.func
};

export default MicrophoneDropdown;
